// extracted by mini-css-extract-plugin
export default {"xs":"0","sm":"576","md":"768","lg":"992","xl":"1200","xxl":"1600","xxxl":"2560"};